import script from "./RegistroGoogleForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistroGoogleForm.vue?vue&type=script&setup=true&lang=js"

import "./RegistroGoogleForm.vue?vue&type=style&index=0&id=afc2867e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afc2867e"]])

export default __exports__